import { useState } from 'react';
import type { SkinTierId } from '../types';

const TIER_RING: Record<SkinTierId, string> = {
  legend: 'ring-mlbb-legend',
  grand_collab: 'ring-mlbb-grand',
  grand_series: 'ring-mlbb-grand',
  collector: 'ring-mlbb-collector',
};

const TIER_GRADIENT: Record<SkinTierId, string> = {
  legend: 'from-yellow-500 to-amber-700',
  grand_collab: 'from-purple-500 to-fuchsia-700',
  grand_series: 'from-purple-500 to-fuchsia-700',
  collector: 'from-sky-500 to-blue-700',
};

export default function SkinIcon({
  icon,
  hero,
  tier,
  size = 56,
  selected = false,
  onClick,
}: {
  icon: string | null;
  hero: string;
  tier: SkinTierId;
  size?: number;
  selected?: boolean;
  onClick?: () => void;
}) {
  const [failed, setFailed] = useState(false);
  const showFallback = !icon || failed;

  return (
    <button
      type="button"
      onClick={onClick}
      className={`relative shrink-0 overflow-hidden rounded-xl ring-2 transition ${
        selected ? TIER_RING[tier] : 'ring-transparent'
      } ${onClick ? 'active:scale-95' : ''}`}
      style={{ width: size, height: size }}
    >
      {showFallback ? (
        <div
          className={`flex h-full w-full items-center justify-center bg-gradient-to-br text-xs font-bold text-white/90 ${TIER_GRADIENT[tier]}`}
        >
          {hero.slice(0, 2).toUpperCase()}
        </div>
      ) : (
        <img
          src={icon}
          alt={hero}
          loading="lazy"
          onError={() => setFailed(true)}
          className="h-full w-full bg-mlbb-border object-cover"
        />
      )}
      {selected && (
        <div className="absolute right-0.5 top-0.5 flex h-4 w-4 items-center justify-center rounded-full bg-black/70 text-[10px] text-white">
          ✓
        </div>
      )}
    </button>
  );
}
